var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('colorTextBtn',{on:{"click":_vm.onCopy}},[_vm._v(" 复制原型 ")])}
var staticRenderFns = []

export { render, staticRenderFns }